import { Button, Center } from "@chakra-ui/react";
import { Link, useSearchParams } from "react-router-dom";
import Empty from "components/Empty";
import { contractsPath } from "constants/paths";

const PageNotFound = ({ returnTo = contractsPath }: { returnTo?: string }) => {
  const [search] = useSearchParams();
  return (
    <Empty
      title="Page Not Found"
      message="The page you’re looking for is not here, sorry for the inconvenience."
      imageSrc="/img/missedTarget.png"
    >
      <Center w="100%">
        <Button
          variant="primary"
          as={Link}
          colorScheme="grey"
          to={search ? `${returnTo}?${search}` : returnTo}
        >
          Return Home
        </Button>
      </Center>
    </Empty>
  );
};

export default PageNotFound;
